// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProductBoxColorVariants{align-items:flex-start;display:none;margin-right:-1rem;margin-top:1.5rem;min-height:1.5rem}@media(min-width:768px){.ProductBoxColorVariants{display:flex}}.ProductBoxColorVariants__label{color:#161616;font-size:.875rem;font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
